module.exports = "<svg version=\"1.1\" id=\"Réteg_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 24 24\" enable-background=\"new 0 0 24 24\" xml:space=\"preserve\"><g><g><rect x=\"16.4\" y=\"17.1\" width=\"1.1\" height=\"2.4\"></rect><polygon points=\"17.1,11.6 19.5,14 19.4,15.3 21.2,15.3 21.2,13.9 19.8,12.5 19.8,7 20.5,7 20.5,5.6 17.1,5.6 \"></polygon></g><path d=\"M15.9,12V4h1V2h-10v2h1v8l-2,2v2h5.2v6h1.6v-6h5.2v-2L15.9,12z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/vwa/components/Pin/pinall.svg
// module id = 922
// module chunks = 0